import { render } from "./DeleteFormConfirmationModal.vue?vue&type=template&id=5606e53f&ts=true"
import script from "./DeleteFormConfirmationModal.vue?vue&type=script&lang=ts"
export * from "./DeleteFormConfirmationModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__